module.exports = __webpack_public_path__ + "img/ro.ad7977a2.jpg";